import { render, staticRenderFns } from "./ProdutorBanco.vue?vue&type=template&id=198ac986"
import script from "./ProdutorBanco.vue?vue&type=script&lang=js"
export * from "./ProdutorBanco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports